"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusShuttles = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
class VenusShuttles extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.VENUS_SHUTTLES,
            tags: [Tags_1.Tags.VENUS],
            cost: 9,
            metadata: {
                cardNumber: 'P89',
                description: 'Add 2 floaters to ANY VENUS CARD.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 12 M€ to raise Venus 1 step. The cost of this action is reduced by 1 for each Venus tag you have, including this.', (eb) => {
                        eb.megacredits(12).venus(1).played.brackets.startAction.venus(1);
                    });
                    b.br.br.br;
                    b.floaters(2).secondaryTag(Tags_1.Tags.VENUS);
                }),
            },
        });
    }
    play(player) {
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.FLOATER, { count: 2, restrictedTag: Tags_1.Tags.VENUS }));
        return undefined;
    }
    canAct(player) {
        const actionCost = Math.max(12 - player.getTagCount(Tags_1.Tags.VENUS), 0);
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = this.getTotalTRGain(player);
        const venusMaxed = player.game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE;
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.actionDetails(actionCost);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
        }
        if (redsAreRuling && !venusMaxed) {
            return player.canAfford(this.reserveUnits.megacredits);
        }
        return player.canAfford(actionCost);
    }
    action(player) {
        const game = player.game;
        const actionCost = Math.max(12 - player.getTagCount(Tags_1.Tags.VENUS), 0);
        if (actionCost > 0) {
            game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, actionCost, { title: 'Select how to pay for action', afterPay: () => {
                    game.defer(new DeferredAction_1.DeferredAction(player, () => {
                        game.increaseVenusScaleLevel(player, 1);
                        return undefined;
                    }));
                } }));
        }
        else {
            game.increaseVenusScaleLevel(player, 1);
        }
        return undefined;
    }
    getTotalTRGain(player) {
        const venusScale = player.game.getVenusScaleLevel();
        let trGain = venusScale === constants_1.MAX_VENUS_SCALE ? 0 : 1;
        if (venusScale === 14)
            trGain += 1;
        return trGain;
    }
    actionDetails(cost) {
        return new RedsPolicy_1.ActionDetails({ cost: cost, venusIncrease: 1 });
    }
}
exports.VenusShuttles = VenusShuttles;
//# sourceMappingURL=VenusShuttles.js.map